export const jwt = 'DC_JWT_TOKEN';
export const dark_theme = 'DC_DARK_THEME';
